import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { RateAndReview } from "../../../../../js/lib/components/RateAndReview";
import { renderInShadow } from "../../../../../js/lib/components/ShadowUtils";
import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { TLCEXT } from "../../../../../js/lib/ext/Ext";
import { TLCLogger } from "../../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { ApplicationData } from "../../ApplicationData";
import { TwirlDown } from "../../controls/TwirlDown";
import { AreYouSurePrompt } from "../../controls/areYouSurePrompt";
import { SimpleErrorDialog } from "../../controls/simpleErrorDialog";
import { SuccessMessageControl } from "../../controls/successMessageControl";
import { LibraryThing } from "../../widget/LibraryThingWidget";
import { BaseDetailView } from "./BaseDetailView";
import * as React from 'react';

export class Titles_Reviews extends BaseDetailView {
  constructor(options) {
    options = options || {};

    options.id = LS2PAC_CONSTANTS.Ids.DetailsPage.reviewsContainer;

    options.resultsTemplate = "tmpl/details/titles_reviews.html";

    super(options);

    this.hasEvents = false;

    this.totalReviews = 0;
    this.borrowerReviewsTwirldown = null;
    this.syndeticsReviewsId = LS2PAC_CONSTANTS.Ids.ReviewsPage.editorialReviews;
    this.borrowerReviewItemTemplate =
      "tmpl/details/titles_reviews_borrower_review.html";
    this.borrowerReviewsId =
      LS2PAC_CONSTANTS.Ids.ReviewsPage.borrowerReviews_content;

    this.addListeners();
  }
  load(resourceData, index, viewName) {
    this.setupSyndetics();
    this.setupBorrowerReviews();
    this.parentClass.updatePagingControls();
    this.addEvents();
  }
  setupSyndetics() {
    if (ApplicationData.locationConfiguration.showEditorialReviewsView()) {
      var enrichment = LibraryThing.enums.enrichments.professionalReviews;
      var twirldown = new TwirlDown(
        enrichment.className,
        ApplicationData.language.editorialReviews
      );
      var target = $("#" + this.syndeticsReviewsId);
      target.empty();
      twirldown.init(
        target,
        (function (twirlDown, enrichment, _this) {
          return function () {
            var targetContainer = twirlDown.getContentContainer();
            LibraryThing.addEnrichment(targetContainer, enrichment);
            _this.refreshSUMetaData(
              targetContainer.selector,
              _this.currentResource,
              function () {
                twirlDown.open();
              }
            );
          };
        })(twirldown, enrichment, this)
      );
    }
  }
  setupBorrowerReviews() {
    if (ApplicationData.locationConfiguration.showBorrowerReviewsView()) {
      var label = ApplicationData.language.borrowerReviews;
      var target = $("#" + this.borrowerReviewsId);
      target.empty();
      this.borrowerReviewsTwirldown = new TwirlDown("borrowerReviews", label);
      this.borrowerReviewsTwirldown.init(
        target,
        (function (twirldown, _this) {
          return function () {
            twirldown.setContent(
              ApplicationData.language.loadingBorrowerReviews
            );
            twirldown.open();
            TLCEventManager.fireEvent(
              LS2PAC_CONSTANTS.Events.onGetBorrowerReviews,
              { resourceId: _this.currentResource.id }
            );
          };
        })(this.borrowerReviewsTwirldown, this)
      );
    }
  }
  updateBorrowerReviewsCount(count) {
    this.totalReviews = count;
    var headerText =
      ApplicationData.language.borrowerReviews + " (" + count + ")";
    this.borrowerReviewsTwirldown.setHeaderText(headerText);
  }
  handleBorrowerReviews(_this) {
    return function (event) {
      TLCLogger.log("handleBorrowerReviews", event);
      if (event.data.reviews.length > 0) {
        _this.updateBorrowerReviewsCount(event.data.totalHits);
        // $("#"+_this.borrowerReviewsHeaderId).find("span").text(event.data.totalHits);
        // var container = $("#"+_this.borrowerReviewsId);
        var container = _this.borrowerReviewsTwirldown.getContentContainer();
        TemplateEngine.fetch(
          _this.borrowerReviewItemTemplate,
          container,
          event.data.reviews,
          function () {
            $.each(event.data.reviews, function (index, review) {
              
              const container = document.querySelector("#rating_" + review.reviewId);
              const average = review.rating;

              renderInShadow(
                <RateAndReview
                  name="rating"
                  readonly={true}
                  resourceId={_this.currentResource.id}
                  averageRating={average}
                ></RateAndReview>,
    
                container,
                ApplicationData.language
              );
              
            });

            if (event.data.nextEnabled) {
              TLCEXT.Template(
                '<input type="button" value="{languageUtil.showMoreReviews}" class="button showMore" />'
              ).append(container, {});
            }
          },
          event.data.currentPage == 1
            ? TemplateEngine.method.overwrite
            : TemplateEngine.method.append
        );
      } else {
        var headerText = ApplicationData.language.borrowerReviews + " (0)";
        _this.borrowerReviewsTwirldown.setHeaderText(headerText);
        _this.borrowerReviewsTwirldown.setContent(
          ApplicationData.language.noBorrowerReviews
        );
        // $("#"+_this.borrowerReviewsHeaderId).find("span").text("0");
        // $("#"+_this.borrowerReviewsId).html(ApplicationData.language.noBorrowerReviews);
      }
    };
  }
  handleRemovedReview(_this) {
    return function (event) {
      if (event.success) {
        const review = $("#review_" + event.id);
        review.fadeOut("slow", function () {
          review.remove();
        });

        _this.updateBorrowerReviewsCount(_this.totalReviews - 1);
        // var total = parseInt($("#"+_this.borrowerReviewsHeaderId).find("span").text(), 10);
        // $("#"+_this.borrowerReviewsHeaderId).find("span").text(total - 1);
        SuccessMessageControl.show(
          ApplicationData.language.successfulReviewRemoval
        );

        // _this.setupBorrowerReviews(); // why are we re-requesting reviews after this?
      } else {
        SimpleErrorDialog.show(ApplicationData.language.errorRemovingReview);
      }
    };
  }
  addListeners() {
    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetBorrowerReviewsResponse,
      this.handleBorrowerReviews(this)
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onRemoveReviewResponse,
      this.handleRemovedReview(this)
    );
  }
  addEvents() {
    if (this.hasEvents == false) {
      var _this = this;
      // $("#"+LS2PAC_CONSTANTS.Ids.DetailsPage.detailsContainer).delegate("#" + this.id + " h4 a", "click", function(event) {
      // 	if($(this).hasClass(LS2PAC_CONSTANTS.CssClasses.open)) {
      // 		$(this).removeClass(LS2PAC_CONSTANTS.CssClasses.open);
      // 	}else {
      // 		$(this).addClass(LS2PAC_CONSTANTS.CssClasses.open);
      // 	}
      // 	var newOpen = $("#"+this.id + "_content");
      // 	newOpen.slideToggle(600);
      // 	return false;
      // });
      $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.detailsContainer).delegate(
        "#" + this.id + " .writeAReview",
        "click",
        function (event) {
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onWriteReview, {
            resource: _this.currentResource,
          });
          return false;
        }
      );

      $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.detailsContainer).delegate(
        "#" + this.id + " .showMore",
        "click",
        function (event) {
          $(event.currentTarget).remove();
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetMoreReviews, {
            resourceId: _this.currentResource.id,
          });
          return false;
        }
      );

      $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.detailsContainer).delegate(
        "#" + this.id + " .removeReview",
        "click",
        function (event) {
          var reviewId = $(event.currentTarget).attr("data-id");
          AreYouSurePrompt.ask(
            ApplicationData.language.areYouSureYouWantToRemoveThisReview,
            function () {
              TLCEventManager.fireEvent(
                LS2PAC_CONSTANTS.Events.onRemoveReview,
                { id: reviewId }
              );
            }
          );
          return false;
        }
      );

      this.hasEvents = true;
    }
  }
}
